import _ from 'lodash'
import $ from 'jquery'
import i18n from 'scoreboard/components/i18n'
import DisplayHeader from 'scoreboard/components/display-header'
import PeriodDisplay from 'scoreboard/components/period-display'
import CalendarPeriodSelector from 'scoreboard/components/calendar-period-selector'
import globals from 'scoreboard/components/globals'
import renderFieldDropdown from './render-field-dropdown'
import DatasetsOverviewInfo from 'scoreboard/datasets/overview/datasets-overview-info'
import appDisplay from 'scoreboard/components/app-display'
import Dataset from 'scoreboard/datasets/model/dataset'
const { ALL_TIME } = Dataset
import spectator from 'scoreboard/components/spectator'
import conductor from 'scoreboard/components/conductor'
import DataType from 'scoreboard/datasets/model/data-type'
const { DATE } = DataType

var DatasetsCalendarPeriodSelector = CalendarPeriodSelector.extend({

	/** @type {Dataset} */
	model: null,

	events: _.defaults({
		'change [name=selectedCalendarFieldIdentifier]': 'changeSelectedCalendarFieldIdentifier'
	}, CalendarPeriodSelector.prototype.events),

	render: function() {
		CalendarPeriodSelector.prototype.render.apply(this, arguments)

		if (this.model.isSelectedCalendarFieldDefined()) {
			this.renderCalendarFieldSelector()
		}

		return this
	},

	renderCalendarFieldSelector: function() {
		// add new HTML
		this.$('.time-selector-content')
			.prepend(
				'<span class="label-text">' +
					_.escape(i18n.get('common.calendar.period.actual')) +
				'</span>')
			.after(
				'<div class="field-selector-content">' +
					'<span class="label-text">' + _.escape(i18n.get('datasets.calendarField')) + '</span>' +
					'<select name="selectedCalendarFieldIdentifier"></select>' +
				'</div>')

		// render the Calendar Field dropdown
		var fields = _.filter(this.model.combinedFields, function(field) {
			return field.dataType === DATE
		})
		var allowedVisibleLinkedFields = _.filter(this.model.get('visibleLinkedFields'), vlf => {
			let field = this.model.getFieldByFieldIdentifier(-1 * vlf.id)
			return field.dataType === DATE
		})
		let selectedId = this.model.idsToFieldIdentifier({
			fieldId: this.model.get('selectedCalendarFieldId'),
			visibleLinkedFieldId: this.model.get('selectedCalendarVisibleLinkedFieldId')
		})
		renderFieldDropdown({
			el: this.$('[name=selectedCalendarFieldIdentifier]'),
			dataset: this.model,
			allowedFieldIds: _.map(fields, 'id'),
			allowedVisibleLinkedFieldIds: _.map(allowedVisibleLinkedFields, 'id'),
			selectedId,
			includeAllTime: true
		})

		this.changeSelectedCalendarFieldIdentifier()
	},

	changeSelectedCalendarFieldIdentifier: function(e) {
		var allTime = ALL_TIME == this.$('[name=selectedCalendarFieldIdentifier]').val()
		this.$('.time-selector-content').toggleClass('is-not-displayed', allTime)

		// If method was called from an event (not render), check to see if the
		// "Show results" button needs enabled
		if (e) {
			this.togglePrimaryButton()
		}
	},

	submit: function(e) {
		this.trigger('change:period', this.periodSelector.val(),
			this.$('[name=selectedCalendarFieldIdentifier]').val())
	}

})

var DatasetsPeriodDisplay = PeriodDisplay.extend({

	/** @type {Dataset} */
	model: null,

	selectorView: DatasetsCalendarPeriodSelector,

	initialize: function(options) {
		PeriodDisplay.prototype.initialize.apply(this, arguments)
	},

	render: function() {
		PeriodDisplay.prototype.render.apply(this, arguments)

		// Prepend instead of inserting before, so we set a max-width on the .text wrapper
		this.$('.text').prepend('<span class="calendar-field"></span>')

		// important: this needs to be called after the .calendar-field is
		// added in the previous call
		this.update()

		return this
	},

	changePeriod: function(newPeriodId, selectedCalendarFieldIdentifier) {
		globals.periodId = newPeriodId

		let previousSelectedCalendarFieldIdentifier = this.model.idsToFieldIdentifier({
			fieldId: this.model.get('selectedCalendarFieldId'),
			visibleLinkedFieldId: this.model.get('selectedCalendarVisibleLinkedFieldId')
		})
		selectedCalendarFieldIdentifier = selectedCalendarFieldIdentifier ||
			previousSelectedCalendarFieldIdentifier

		if (this.periodId != newPeriodId ||
			selectedCalendarFieldIdentifier != previousSelectedCalendarFieldIdentifier) {
			// it's a little awkward to do this in the period display, but it's
			// important this gets set before the change:period event is fired
			// so that we send a new request to the server with the correct
			// selectedCalendarFieldId and selectedCalendarVisibleLinkedFieldId
			if (!_.isNil(selectedCalendarFieldIdentifier)) {
				let selectedCalendarIds = this.model.fieldIdentifierToIds(selectedCalendarFieldIdentifier)
				this.model.set({
					selectedCalendarFieldId: selectedCalendarIds.fieldId,
					selectedCalendarVisibleLinkedFieldId: selectedCalendarIds.visibleLinkedFieldId
				})
			}
			this.trigger('change:period', newPeriodId, selectedCalendarFieldIdentifier)
		}
		this.refresh(newPeriodId)

		// Prepend instead of inserting before, so we set a max-width on the .text wrapper
		this.$('.text').prepend('<span class="calendar-field"></span>')

		// important: this needs to be called after the .calendar-field is
		// added in the previous call
		this.update()
	},

	refresh: function(periodId, selectedCalendarFieldIdentifier) {
		PeriodDisplay.prototype.refresh.apply(this, arguments)
		if (this.model.get('selectedCalendarFieldId') == ALL_TIME) {
			this.$('.backward button, .forward button').prop('disabled', true)
		}
	},

	update: function() {
		this.$('.calendar-field').addClass('is-not-displayed')
		let selectedCalendarFieldId = this.model.get('selectedCalendarFieldId')
		if (selectedCalendarFieldId == ALL_TIME) {
			this.$('.text').text(i18n.get('common.allTime'))
		} else {
			// update the period label, e.g. set it to April 2017
			PeriodDisplay.prototype.update.apply(this, arguments)
			// update the field label
			if (this.model.isSelectedCalendarFieldDefined()) {
				let label = this.model.getFieldLabelByIds({
					fieldId: selectedCalendarFieldId,
					visibleLinkedFieldId: this.model.get('selectedCalendarVisibleLinkedFieldId')
				})
				this.$('.calendar-field').removeClass('is-not-displayed')
					.text(label)
			}
		}
	}

})

var DatasetsDisplayHeader = DisplayHeader.extend({

	/** @type {Dataset} */
	model: null,

	initialize: function(options) {
		DisplayHeader.prototype.initialize.apply(this, arguments)
		// we need a period selector to be rendered
		this.options.periods = true
	},

	render() {
		DisplayHeader.prototype.render.apply(this, arguments)
		if (!this.model.isViewRecordsTab()) {
			this.$('.records-tab').remove()
		}
		this.secure()
		return this
	},

	secure: function() {
		DisplayHeader.prototype.secure.apply(this, arguments)
		this.conditionallyHideEditTab(this.model.isEditable())
	},

	_createSpecificDatePeriodDisplay: function() {
		this.periodDisplay = new DatasetsPeriodDisplay({
			model: this.model,
			selectedCalendarFieldIdentifier: this.model.getCalendarFieldIdentifier(),
			// changing the period isn't destructive in datasets
			guard: false
		})

		this.periodDisplaySetup()
		this.periodDisplay.on('change:period', () => this.periodDisplaySetup())
	},

	periodDisplaySetup: function() {
		process.nextTick(() => {
			this.setPeriodDisplayTruncator()
			this.setPeriodDisplayMaxWidth()
		})
	},

	// The period-display tab
	setPeriodDisplayMaxWidth: function() {
		var containerWidth = this.$('.tabs').width()
		// Calculate the surrounding width so we know how much room the period display text can take up.
		// Start with the pre-determined values that won't change (i.e. padding, icon only buttons)
		var surroundingWidth = 190
		_.each(this.$('.tab:not(.period-display)'), function(tab) {
			surroundingWidth += $(tab).width()
		})
		var displayText = this.$('.tab.period-display .text')
		displayText.css('max-width', (containerWidth - surroundingWidth) + 'px')
		this.$('.tab.period-display .calendar-field').css('max-width', 'calc(100% - ' + this.$('.tab.period-display .period').width() + 'px)')
		// If field label is hidden and the width of the `.text` is going to be too wide, we need
		// to manually tell it to hide its overflow
		let overflow = displayText.find('.period').width() < displayText.width() ?
			'visible' : 'hidden'
		displayText.css({ overflow })
	},

	// Allows the calendar field label to be truncated first because we want the period text to
	// always be displayed if possible. Period text will get truncated after the calendar field is
	// completely hidden.
	setPeriodDisplayTruncator: function() {
		var displayText = this.$('.tab.period-display .text')
		var field = displayText.find('.calendar-field')
		if (!_.isEmpty(field)) {
			var period = `<span class="period">` + displayText.text().replace(field.text(), '') + `</span>`
			displayText.empty().append(field[0].outerHTML + period)
		}
	},

	overviewInfo: function() {
		var dataset = new Dataset({ id: this.model.id })
		appDisplay.dialog(dataset.fetch({
			data: {
				relatedItems: true,
				linkedDatasets: true,
				supportingForms: true
			}
		}), () => new DatasetsOverviewInfo({ model: dataset }))
	},

	// Called when this display header is being rendered as a part of a spectated view
	// (ex. bookmark or briefing)
	spectate: function() {
		DisplayHeader.prototype.spectate.apply(this, arguments)
		// Hide either the Explore or Records tab based on which one we're currently
		// spectating. Both of those tabs can be spectated separately.
		// This makes it so this header is in line with other spectated headers
		// that only feature the 'View' and 'Edit Slide' tabs.
		if (spectator.getCurrent().get('url').indexOf('records') >= 0) {
			this.$('.overview-tab').remove()
		} else {
			this.$('.records-tab').remove()
		}

		this._renameOverviewTab()

		// Update the 'edit' tab to point to the 'edit bookmark' url if this is a bookmrk header
		let isBookmark = conductor.section() == 'bookmarks'
		if (isBookmark) {
			this._updatedSpectatedEditTabUrl()
		}

		// Sometimes, we'll need to edit the datasets header edit tab to read 'Edit Slide'.
		// We do so under these conditions:
		// - We're not spectating this as a bookmark
		// - We're viewing dataset as a part of a briefing
		// - That briefing is not currently playing (we haven't loaded this view by way of a drilldown click)
		let notAFolder = this._isNonFolder()
		let notFromDrilldown = !this.options.drilldown
		if (!isBookmark && notAFolder && notFromDrilldown) {
			this._updateSpectatedEditTab()
		}
	}
})

export default DatasetsDisplayHeader

DatasetsDisplayHeader.__filename__ = 'datasets/datasets-display-header.js'
